import { useQuery } from 'react-query'
import { axios } from '../../../lib'

interface Params {
  particularId: string
  configuration: string
  productId: string
  customerId: string
  configurationId?: string
  enabled: boolean
}

//! TODO: response type

export const loadOrdersProductParticularsOptions = (
  params: Params
): Promise<any> => {
  return axios.get(
    `/orders/products/particulars/${params.particularId}/contents`,
    {
      params: {
        ...params,
        page: 1,
        limit: 100
      }
    }
  )
}

export function useLoadOrdersProductsParticularsOptions(query: Params) {
  return useQuery(
    ['ordersProductParticularsOptions', query],
    () => loadOrdersProductParticularsOptions(query),
    {
      enabled:
        !!query.particularId &&
        !!query.configuration &&
        !!query.productId &&
        !!query.customerId &&
        !!query.configurationId &&
        !!query.enabled
    }
  )
}
